<template>
  <div class="text-right" v-if="store.calcOrderTotalPriceNoVat() > 0">
<div class="row mb-1"  style="font-weight: 600; font-size: 18px;">
  <div class="col-6 text-left">
    {{t('total.priceWithVat')}}:
  </div>
  <div class="col-6 text-secondary">
     {{ totalPriceWithVat }}
  </div>
</div>
    <div class="row" style="font-size: 14px;">
      <div class="col-6 text-left">
        {{t('total.priceWithoutVat')}}:
      </div>
      <div class="col-6">
        {{ totalPriceNoVat }}
      </div>
    </div>


  </div>
</template>

<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'

export default {
  name: "TotalPrice",
  data() {
    return {
      store
    }
  },
  setup() {
    const {t,locale} = useI18n({useScope: 'global'})
    const select = ref(0)
    const lang = locale
    return {t, select, lang}
  },
  computed: {
    totalPriceNoVat() {
      var price = store.calcOrderTotalPriceNoVat()
      return store.priceFilter(price);
    },
    totalPriceWithVat() {
      var price = store.calcOrderTotalPriceWithVat()
      return store.priceFilter(price);
    },


  }

}
</script>

<style scoped>

</style>